import useSWR from "swr";

// WIP: Dev CDN
// const CDN_URL = process.env.NEXT_ENV === "production" ? process.env.CDN_BASE_URL : `${process.env.CDN_BASE_URL}/dev`;
const CDN_URL = process.env.CDN_BASE_URL;

type ResponseFormat = "json" | "text" | "blob" | "arrayBuffer";

export function useCdn<T>(key: string, format: ResponseFormat = "json", fallbackData?: unknown) {
  const path = CDN_URL + key;
  const { data, error, mutate, isLoading, isValidating } = useSWR(
    path,
    async (url) => {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch");
      }
      switch (format) {
        case "json": {
          return response.json();
        }
        case "text": {
          return response.text();
        }
        case "blob": {
          return response.blob();
        }
        case "arrayBuffer": {
          return response.arrayBuffer();
        }
        default: {
          return response.json();
        }
      }
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000,
      fallbackData,
    }
  );

  return {
    data: data as T,
    isLoading,
    isValidating,
    error,
    mutate,
  };
}
